<template>
  <span v-if="this.column.displayValue && this.column.displayValue !== null">{{ displayValue }}</span>
  <span v-else-if="value && titleColumn" class="column">
    <span class="text-primary">{{ value | relationLabel(titleColumn) }}</span>
    <span
      v-if="subtitleColumn"
      class="text-grey-7 q-caption"
    >{{ value | relationLabel(subtitleColumn) }}</span>
  </span>
</template>

<script>
export default {
  name: 'grid-cell-relation-one',
  props: {
    column: {
      required: true,
      type: Object
    },
    row: Object,
    value: {
      required: true
    }
  },

  computed: {
    displayValue () {
      if (this.column.displayValue && this.column.displayValue !== null) {
        if (typeof this.column.displayValue === 'function') {
          return this.column.displayValue(this.value, this.row)
        }
      }
    },
    namespace () {
      return this.column && this.column.relation && this.column.relation.namespace ? this.column.relation.namespace : undefined
    },
    titleColumn () {
      return this.namespace ? this.$store.getters[`${this.namespace}/titleColumn`] : undefined
    },
    subtitleColumn () {
      return this.namespace ? this.$store.getters[`${this.namespace}/subtitleColumn`] : undefined
    }
  }
}
</script>
